import {Component, Input} from '@angular/core';
import {
  CategoryItem,
  LeagueRoundResultMeta, LeagueStandingsMeta, LeagueStandingsRace,
  Lookups,
} from "@model";
import {
  LEAGUES_MANAGEMENT_RESULTS_BY_ROUND,
  LEAGUES_MANAGEMENT_RESULTS_OVERALL
} from "../../../../../app-routing.module";

@Component({
  selector: 'app-league-results-management',
  templateUrl: './league-results-management.component.html',
  styleUrl: './league-results-management.component.scss',
  standalone: false,
})
export class LeagueResultsManagementComponent {
  readonly BY_ROUND = LEAGUES_MANAGEMENT_RESULTS_BY_ROUND;
  readonly OVERALL = LEAGUES_MANAGEMENT_RESULTS_OVERALL;

  ngOnInit() {
  }
}